import { InputHTMLAttributes } from 'react';

type RoundedCheckboxProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'type'>;

export function RoundedCheckbox({ className = '', ...props }: RoundedCheckboxProps) {
  return (
    <input
      type="checkbox"
      className={`h-4 w-4 rounded-md border-secondary-300 text-primary-500 focus:ring-primary-500 focus:ring-offset-0 ${className}`}
      {...props}
    />
  );
}
